import { ICompany, ICompanyCreate, ICompanyForm, ICompanyUpdate } from '../typing/company.interface';
import { CashProviderEnum } from '../enums/cash-provider.enum';

export class Company {
    data: ICompany;

    constructor(data: ICompany){
        this.data = data;
    }

    dataForCreate(formData: ICompanyForm): ICompanyCreate{
        return {
            name: formData.name,
            settings: {
                timeZone: formData.timeZone,
                paymentDevice: formData.paymentDevice,
                canExecutorChangePrice: formData.canExecutorChangePrice,
                canExecutorAddEquipment: formData.canExecutorAddEquipment,
                cashProvider: formData.cashProvider || null,
                cashProviderConfig: this.parseConfig(formData.cashProviderConfigJson),
            }
        };
    }

    dataForUpdate(formData: ICompanyForm): ICompanyUpdate {
        return {
            id: this.data.id,
            name: formData.name,
            settings: {
                timeZone: formData.timeZone,
                paymentDevice: formData.paymentDevice,
                canExecutorChangePrice: formData.canExecutorChangePrice,
                canExecutorAddEquipment: formData.canExecutorAddEquipment,
                cashProvider: formData.cashProvider || null,
                cashProviderConfig: this.parseConfig(formData.cashProviderConfigJson),
            }
        };
    }

    formData(): ICompanyForm {
        return {
            name: this.data.name,
            timeZone: this.data.settings?.timeZone,
            paymentDevice:this.data.settings?.paymentDevice || false,
            canExecutorChangePrice: this.data.settings?.canExecutorChangePrice || false,
            canExecutorAddEquipment: this.data.settings?.canExecutorAddEquipment || false,
            cashProvider: (this.data.settings?.cashProvider as CashProviderEnum | undefined) || CashProviderEnum.aqsi,
            cashProviderConfigJson: this.data.settings?.cashProviderConfig
                ? JSON.stringify(this.data.settings.cashProviderConfig, null, 2)
                : '',
        };
    }

    private parseConfig(configJson?: string): Record<string, unknown> | null {
        if (!configJson?.trim()) {
            return null;
        }

        try {
            return JSON.parse(configJson) as Record<string, unknown>;
        } catch {
            return null;
        }
    }
}
